<template>
    <div>
        <h4>Tambah Blacklist Nomor</h4>
        <hr>
        <form v-on:submit.prevent="submit">
            <div class="form-group">
                <label for="number">Nomor WhatsApp</label>
                <input 
                    type="text" 
                    class="form-control" 
                    id="number" 
                    v-model="form.number" 
                    placeholder="Contoh: 6281234567890 atau 081234567890"
                    required
                >
                <small class="form-text text-muted">
                    Masukkan nomor yang ingin di-blacklist. Nomor akan diformat otomatis.
                </small>
            </div>
            <div class="form-group">
                <button type="submit" class="btn btn-primary" :disabled="isLoading">
                    <span v-if="isLoading">Loading...</span>
                    <span v-else>Tambah</span>
                </button>
                <button type="button" class="btn btn-secondary ml-2" v-on:click="cancel">
                    Batal
                </button>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    props: ['id'],
    data() {
        return {
            form: {
                number: ''
            },
            isLoading: false
        };
    },
    methods: {
        async submit() {
            if (!this.form.number || this.form.number.trim() === '') {
                this.$toast.error('Nomor tidak boleh kosong');
                return;
            }

            this.isLoading = true;
            try {
                let response = await this.$store.dispatch("chatgpt_create_blacklist", {
                    id: this.id,
                    number: this.form.number
                });
                this.$toast.success(response.data.message);
                this.form.number = '';
                this.$root.$emit("refresh_table", true);
                this.$root.$emit("toggle_modal", "add_blacklist");
            } catch (err) {
                this.$toast.error(err.response?.data?.message || "Gagal menambah blacklist");
            }
            this.isLoading = false;
        },
        cancel() {
            this.form.number = '';
            this.$root.$emit("toggle_modal", "add_blacklist");
        }
    }
};
</script>

<style scoped>
</style>


